const common = {
  YANDEX_MAP_API_KEY: '',
  PRODUCTS_SORT_OPTIONS: [
  ],
};

export default common;
